<template>
    <div class="absolute block top-0 left-0 w-full h-full">
        <div ref="root" class="w-full h-full" />
    </div>
</template>

<script setup>
    import { onMounted, ref } from 'vue';
    import mapboxgl from 'mapbox-gl';
    import 'mapbox-gl/dist/mapbox-gl.css';
    import icon from '../../img/icons/marker.svg?url';

    mapboxgl.accessToken = 'pk.eyJ1IjoidGFzZGV2IiwiYSI6ImNtN2s2dmt3aDBlYWIyanByZm9vMXczdncifQ.vFtItFsNB2bBN11sHipP_g';

    const props = defineProps({
        center: {
            type: Array,
            required: true,
        },
        markers: {
            type: Array,
            default: () => [],
        },
    });

    const root = ref(null);
    const instance = ref(null);

    const initMap = () => {
        if (!root.value) {
            setTimeout(initMap, 100);
            return;
        }

        instance.value = new mapboxgl.Map({
            container: root.value,
            center: props.center,
            zoom: 14,
            style: 'mapbox://styles/mapbox/light-v11',
        });

        for (const marker of props.markers) {
            const el = document.createElement('div');
            el.className = 'marker';
            el.style.backgroundImage = import.meta.env.DEV ? `url(/dist/${icon})` : `url(${icon})`;

            new mapboxgl.Marker(el).setLngLat(marker.coordinates).addTo(instance.value);
        }
    };

    onMounted(initMap);
</script>

<style lang="postcss">
    .marker {
        background-size: cover;
        width: 50px;
        height: 50px;
    }
</style>
